import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)
class GspAnimate {
    constructor() {
        this.fadeUp=document.querySelectorAll(".fadeUp");
    }
    gspFadeUp(){
        if(this.fadeUp){
            this.fadeUp.forEach(fu => {
                gsap.to(fu, {
                    duration:0.5,
                    y: 0,
                    autoAlpha: 1,
                    stagger: 0.2,
                    scrollTrigger: {
                        trigger: fu,
                        start: "top-=100 60%",
                        // markers:true
                    }
                })
            });
        }
    }
    StagerAnimation(stagerElm) {
        stagerElm.length && this.setStagerAnimation(stagerElm);
    }
    setStagerAnimation = (elm) => {
        const params = {
            onEnter: (elm) => this.setAnimation(elm),
            start: "top-=100 60%",
            once: true,
            // markers:true,
        };
        gsap.set(elm, { opacity: 0 });
        return ScrollTrigger.batch(
            elm,
            params, 
        );
    };
    setAnimation = (elm) => {
        const params={
            fromY: 70, 
            toY: 0, 
            fromX: 0, 
            toX: 0, 
            duration: 1, 
            opacityDuration: 1, 
            stagger: 0.1, 
            ease: "expo.out",
        };
        const tl = new gsap.timeline();
        gsap.set(elm, { opacity: 0, y: params.fromY });
        tl.set(elm, { willChange: 'transform' });
        tl.fromTo(elm, { opacity: 0, y: params.fromY, x: params.fromX }, {opacity: 1, y: params.toY, x: params.toX, duration: params.duration, stagger: params.stagger, ease: params.ease }, 0);
        tl.set(elm, { willChange: 'auto' });
        return tl;
    };
}
export default GspAnimate